/**
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { getFromENV, getAsBooleanFromENV } from './env';

const _debugMode = getFromENV('PWDEBUG') || '';

export function debugMode() {
  if (_debugMode === 'console')
    return 'console';
  if (_debugMode === '0' || _debugMode === 'false')
    return '';
  return _debugMode ? 'inspector' : '';
}

let _isUnderTest = getAsBooleanFromENV('PWTEST_UNDER_TEST');
export function setUnderTest(): void {
  _isUnderTest = true;
}

export function isUnderTest(): boolean {
  return _isUnderTest;
}
